import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { OESettingsService } from "app/order-entry/services/basic/oe-settings.service";
import { Subscription } from "rxjs";
import { DashboardMenuItem } from "../bfx-common/models/dashboard-menu-item";
import { BfxNewOrderMenuService } from "../bfx-common/services/bfx-neworder-menu.service";
import { GoldenLayoutService } from "../golden-layout/golden-layout-service";

import { LoggerService } from "@bfx/logger";
import { ProfilePromiseActionService, ProfileSettingKeys } from "shared/cubiq-services";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-neworder-menu",
  templateUrl: "./html/bfx-neworder-menu.component.html",
  standalone: false,
})
export class BfxNewOrderMenuComponent implements OnInit, OnDestroy {
  item: number;
  menuItems: DashboardMenuItem[];
  hasMenuItems: boolean = false;
  hasMultipleMenuItems: boolean = false;

  // @ViewChild("singleButton", { static: true }) button: ElementRef;

  public defaultTooltip: string = "";

  private profileUpdatesSub: Subscription;

  constructor(
    // private goldenLayoutService: GoldenLayoutService,
    private neworderMenuService: BfxNewOrderMenuService,
    private settings: OESettingsService,
    private profileLookup: ProfilePromiseActionService,
    private button: ElementRef,
  ) {}

  ngOnInit() {
    this.profileUpdatesSub = this.profileLookup
      .getProfileConfigUpdates(ProfileSettingKeys.userOrderEntryPreferencesSettings)
      .subscribe(this.updateFromSettings.bind(this));

    this.neworderMenuService.getMenuProvider().then((values) => {
      if (values.length > 0) {
        this.menuItems = values;
        this.hasMenuItems = true;
        this.hasMultipleMenuItems = values.length > 1;
        values.forEach((value) => (value.icon = "icon_ion_document"));
      }
      this.updateFromSettings();
    });
  }

  ngOnDestroy(): void {
    if (this.profileUpdatesSub) {
      this.profileUpdatesSub.unsubscribe();
    }
  }

  private updateFromSettings() {
    if (this.hasMenuItems) {
      const defaultOrderType: string = this.settings.newOrderTypeDefault;
      let menuItem: DashboardMenuItem;
      if (defaultOrderType) {
        menuItem = this.menuItems.find((element) => element.id == defaultOrderType);
      }
      this.defaultTooltip = menuItem?.label ?? this.menuItems[0].label;
    } else {
      this.defaultTooltip = "";
    }
  }

  // toggle(menu: any, $event: any): any {
  //   if (this.hasMenuItems) {
  //     if (this.menuItems.length > 1) {
  //       menu.toggle($event);
  //     } else if (this.menuItems.length === 1) {
  //       let menuItem = this.menuItems[0];
  //       menuItem.command({ item: menuItem, originalEvent: $event });
  //     }
  //   }
  // }

  activateDefault(): any {
    if (this.hasMenuItems) {
      this.button.nativeElement.blur();
      // Find the default in the menu list and trigger
      let defaultOrderType: string = this.settings.newOrderTypeDefault;
      let menuItem = this.menuItems.find((element) => element.id == defaultOrderType);
      if (menuItem == null) {
        menuItem = this.menuItems[0];
      }
      menuItem.command({ item: menuItem, originalEvent: null });
    }
  }
}
